/**
 * Color Scheme Utility
 * Defines the Cyan/Violet/Amber/Neon-Green aesthetic
 */

// Primary color palette
export const COLORS = {
  CYAN: '#00ffff',        // Cyan blue
  VIOLET: '#8b00ff',      // VIOLET purple (not magenta)
  AMBER: '#ff8c00',       // Amber orange
  NEON_GREEN: '#39ff14',  // Vibrant neon green
  WHITE: '#ffffff',
  BLACK: '#000000'
};

/**
 * Get node color based on group
 */
export const getNodeColor = (node) => {
  const groupColors = {
    'ontology': COLORS.CYAN,
    'geometry': COLORS.VIOLET,
    'lineage': COLORS.AMBER,
    'synthesis': COLORS.NEON_GREEN,
    'general': COLORS.WHITE
  };

  return node.color || groupColors[node.group] || COLORS.CYAN;
};

/**
 * Get node shape based on characteristics
 */
export const getNodeShape = (node) => {
  // ALL NODES ARE SPHERES - sacred geometry balls
  return 'sphere';
};

/**
 * Get edge color based on type
 */
export const getEdgeColor = (edgeType) => {
  const edgeColors = {
    'recursion_link': COLORS.CYAN,
    'semantic_link': COLORS.AMBER,
    'temporal_link': COLORS.NEON_GREEN,
    'structural_link': COLORS.WHITE,
    'geometric_link': COLORS.VIOLET,
    'lineage_link': '#ffdd00' // Gold
  };

  return edgeColors[edgeType] || COLORS.CYAN;
};

/**
 * Get edge style properties based on type
 */
export const getEdgeStyle = (edgeType) => {
  const styles = {
    'recursion_link': {
      width: 2,
      opacity: 0.8,
      dashed: false,
      curve: true,
      particles: true
    },
    'semantic_link': {
      width: 1.5,
      opacity: 0.6,
      dashed: false,
      curve: true,
      particles: false
    },
    'temporal_link': {
      width: 3,
      opacity: 0.9,
      dashed: false,
      curve: false,
      particles: true
    },
    'structural_link': {
      width: 1,
      opacity: 0.4,
      dashed: true,
      curve: false,
      particles: false
    },
    'geometric_link': {
      width: 2,
      opacity: 0.7,
      dashed: false,
      curve: true,
      particles: false
    },
    'lineage_link': {
      width: 1.5,
      opacity: 0.5,
      dashed: true,
      curve: false,
      particles: false
    }
  };

  return styles[edgeType] || {
    width: 1,
    opacity: 0.5,
    dashed: false,
    curve: false,
    particles: false
  };
};

/**
 * Generate color with opacity
 */
export const colorWithOpacity = (color, opacity) => {
  // Convert hex to rgba
  const hex = color.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

/**
 * Get gradient for backgrounds
 */
export const getGradient = (type = 'main') => {
  const gradients = {
    'main': `linear-gradient(135deg, ${COLORS.BLACK} 0%, ${colorWithOpacity(COLORS.CYAN, 0.1)} 100%)`,
    'panel': `linear-gradient(180deg, ${colorWithOpacity(COLORS.BLACK, 0.95)} 0%, ${colorWithOpacity(COLORS.CYAN, 0.05)} 100%)`,
    'accent': `linear-gradient(90deg, ${COLORS.CYAN} 0%, ${COLORS.VIOLET} 50%, ${COLORS.AMBER} 100%)`
  };

  return gradients[type] || gradients['main'];
};